import React from 'react'
import { Container, Card } from '@scentregroup/ui'
import classNames from 'classnames'
import Article from '../article'
import Markdown from '../markdown'
import { CustomThemeContext, useEvolvedContext } from '../../context'
import ServiceUtilityBox from '../service-utility-box'
import { RawOpeningHours, Centre } from '../../../types/contentful-v1'
import { ContentAnalyticsMetaData } from '../../../types/contentful'
import Trackable from '../trackable'
import { trackingActions, trackingTypes } from '../../constants'
import style from '../feature/index.module.scss'

interface ServiceFeatureProps {
  position: 'left' | 'right'
  topic: string
  title: string
  body: string
  centred: boolean
  centre: Centre
  centreTradingHours: RawOpeningHours
  analyticsMetadata?: ContentAnalyticsMetaData
}

const ServiceFeature: React.FunctionComponent<ServiceFeatureProps> = ({
  position,
  topic,
  title,
  body,
  centred = false,
  centre,
  centreTradingHours,
  analyticsMetadata,
}) => {
  const isEvolved = useEvolvedContext()

  return (
    <Trackable
      {...analyticsMetadata}
      trackingAction={trackingActions.viewPromotion}
      type={trackingTypes.promotion}
    >
      <CustomThemeContext.Consumer>
        {themeOption => (
          <div
            className={classNames(
              style.Feature,
              style.ServiceFeature,
              style.placeholder,
              {
                [style.placeholderNotEvolved]: !isEvolved,
                [style.Grey]: themeOption.luxury,
                [style.evolved]: isEvolved,
              }
            )}
          >
            <Container
              centred
              type="large"
              className={classNames(style.Container, style[position])}
            >
              <Card
                className={classNames(style.Card, { [style.centred]: centred })}
              >
                <Article superheading={topic} heading={title}>
                  <Markdown content={body} />
                </Article>
              </Card>
              <div className={style.Sidebar}>
                <ServiceUtilityBox
                  centre={centre}
                  centreTradingHours={centreTradingHours}
                  storeTradingHours={
                    centre.conciergeService && centre.conciergeService.store
                      ? centre.conciergeService.store.storeTradingSchedule
                      : undefined
                  }
                />
              </div>
            </Container>
          </div>
        )}
      </CustomThemeContext.Consumer>
    </Trackable>
  )
}

export default ServiceFeature
